module.exports = __webpack_public_path__ + "img/fallback-slide.1280x1280.de.d11c6c2a.png";